import { ca } from '@cian/analytics';

export function trackSelectionButtonClick() {
  ca('eventSite', {
    action: 'click',
    category: 'CardJK',
    label: 'to_newbuilding_finder',
    name: 'oldevent',
    useLastProducts: true,
  });
}
